module.exports = __webpack_public_path__ + "static/GetStarted-4-8f1c5849698b74ab9e7745c0ca669d58.jpg";